import { ReactNode } from 'react'
import { StyleContainer } from './style'
import theme from '@utils/theme'

interface IContainer {
  children?: ReactNode
  customStyle?: any
  bg?: keyof typeof theme.colors
}
const Container = ({ children, customStyle }: IContainer) => {
  return <StyleContainer {...customStyle}>{children}</StyleContainer>
}

export default Container
